import { baseApi } from "./base.api";

export const bannersApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchBanners: build.query({
      query: (params) => ({ url: "/banners/fetch", method: "GET", params }),
      providesTags: ["Banner"],
    }),
    fetchBannersAll: build.query({
      query: () => ({ url: "/banners/fetch/all", method: "GET" }),
      providesTags: ["Banner"],
    }),
    fetchTrashedBanners: build.query({
      query: (params) => ({ url: "/banners/fetch/trashed", method: "GET", params }),
      providesTags: ["Banner"],
    }),
    fetchBannerById: build.query({
      query: (id) => ({ url: `/banners/fetch/${id}`, method: "GET" }),
      providesTags: ["Banner"],
    }),
    createBanner: build.mutation({
      query: (body) => ({ url: "/banners/create", method: "POST", body }),
      invalidatesTags: ["Banner"],
    }),
    updateBanner: build.mutation({
      query: ({ id, body }) => ({ url: `/banners/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["Banner"],
    }),
    changeBannerStatus: build.mutation({
      query: (id) => ({ url: `/banners/status/${id}`, method: "PUT" }),
      invalidatesTags: ["Banner"],
    }),
    restoreBanner: build.mutation({
      query: (id) => ({ url: `/banners/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["Banner"],
    }),
    bulkRestoreBanners: build.mutation({
      query: (body) => ({ url: "/banners/bulk-restore", method: "POST", body }),
      invalidatesTags: ["Banner"],
    }),
    deleteBanner: build.mutation({
      query: (id) => ({ url: `/banners/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["Banner"],
    }),
    bulkDeleteBanners: build.mutation({
      query: (body) => ({ url: "/banners/bulk-delete", method: "POST", body }),
      invalidatesTags: ["Banner"],
    }),
    destroyBanner: build.mutation({
      query: (id) => ({ url: `/banners/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["Banner"],
    }),
    bulkDestroyBanners: build.mutation({
      query: (body) => ({ url: "/banners/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["Banner"],
    }),
  }),
});

export const {
  useFetchBannersQuery,
  useFetchBannersAllQuery,
  useFetchTrashedBannersQuery,
  useFetchBannerByIdQuery,
  useCreateBannerMutation,
  useUpdateBannerMutation,
  useChangeBannerStatusMutation,
  useRestoreBannerMutation,
  useBulkRestoreBannersMutation,
  useDeleteBannerMutation,
  useBulkDeleteBannersMutation,
  useDestroyBannerMutation,
  useBulkDestroyBannersMutation,
} = bannersApi;
